import React, { useEffect } from 'react';
import "../register.css";
import * as FaIcons from 'react-icons/fa';
import { Dropdown } from 'react-bootstrap';
import { EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { getAPI } from '../GdacsAPI';
import { useViewPort } from '../Hooks/useViewPort';

const NewAddressRow = (props) => {
    const [servicestypes, setServicesTypes] = React.useState([]);
    const [mailOptions, setMailOptions] = React.useState([]);
    const [address, setAddress] = React.useState({ idServiceType: undefined, addressValue: "", addressOption: "html", checkcode: null, checkvalidate: false, checkdate: null, requiretest: false });
    const [toggleContents, setToggleContents] = React.useState();
    const [toggleOptions, setToggleOptions] = React.useState();
    const [isDisabled, setIsDisabled] = React.useState(false);
    const [isDisabledSelect, setIsDisabledSelect] = React.useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const { width } = useViewPort();
    const breakpoint = 620;
    const [responseMessage, setResponseMessage] = React.useState("");
    const [isModified, setIsModified] = React.useState("");


    async function GetServicesTypes() {
        var url = getAPI() + `api/register/Definition/servicetype/`;
        const response = await fetch(url);
        if (!response.ok) {
            setServicesTypes('Failed to retreive services types data.');
            return;
        }
        const servicesTypesData = await response.json();
        if (servicesTypesData) {
            setServicesTypes(servicesTypesData);
            setMailOptions(servicesTypesData[0].listOptions);
        }
    }

    React.useEffect(() => {
        props.isButtonDisabled(isButtonDisabled);
        props.responseMessage(responseMessage);
        props.isModified(isModified);
    }, [])

    React.useEffect(() => {
        GetServicesTypes();
    }, []);

    React.useEffect(() => {
        if (servicestypes.length > 0) {
            const newValue = parseInt(servicestypes[0].idServiceType);
            setAddress((a) => ({ ...a, idServiceType: newValue }));
        }
    }, [servicestypes]);

    React.useEffect(() => {
        if (mailOptions.length > 0) {
            const newValue = mailOptions[0];
            setAddress((a) => ({ ...a, addressOption: newValue }));
        }
        else {
            const newValue = "Html";
            setAddress((a) => ({ ...a, addressOption: newValue }));
        }
    }, [mailOptions]);

    const handleChangeValue = (e) => {
        const newValue = e.currentTarget.value;
        setAddress((a) => ({ ...a, addressValue: newValue }));
        props.responseMessage("");
        props.isModified(true);
    }

    const handleChangeService = (e) => {
        /*        const newValue = e.target.value;*/
        setAddress((a) => ({ ...a, idServiceType: parseInt(e) }));
        if (parseInt(e) === 10) {
            setIsDisabled(true);
            setIsDisabledSelect(true);
        }
        else if (parseInt(e) === 3) {
            setIsDisabled(false);
            setIsDisabledSelect(true);
        }
        else {
            setIsDisabled(false);
            setIsDisabledSelect(false);
        }
        props.responseMessage("");
        props.isModified(true);
    }

    const handleChangeOption = (e) => {
        setAddress((a) => ({ ...a, addressOption: e }));
        props.responseMessage("");
        props.isModified(true);
    }

    const handleFilterAddress = (e, id) => {
        const obj = [...servicestypes];
        let filteredArray = obj.filter(item => item.idServiceType === id)
        obj.listOptions = filteredArray[0].listOptions;
        setMailOptions(obj.listOptions);

    }

    const icons = {
        "1": <EnvelopeFill color="#0099CC" size={18} />,
        "3": <Telephone color="#0099CC" size={18} />,
        "10": <Phone color="#0099CC" size={18} />,
    };

    return (
        <tr key="id">
            <td className="cell_hidden">{props.address.id}</td>
            <td className="cell_hidden">{props.address.idUserAddress}</td>
            <td style={{ textAlign: "center" }}>
                <Dropdown onSelect={eventKey => {
                    setToggleContents(icons[eventKey]);
                }}>
                    <Dropdown.Toggle id="dropdown-custom-components" variant="light">
                        {!toggleContents ? <EnvelopeFill color="#0099CC" size={18} /> : toggleContents}
                    </Dropdown.Toggle>

                    <Dropdown.Menu value={address.idServiceType} style={{ maxHeight: 300, overflowY: 'scroll' }}>
                        {
                            servicestypes.map((item) => {
                                return (<Dropdown.Item value={item.idServiceType} key={item.idServiceType} eventKey={item.idServiceType} onSelect={handleChangeService} onClick={(e) => handleFilterAddress(e, item.idServiceType)}>
                                    {item.idServiceType === 1 ?
                                        <EnvelopeFill color="#0099CC" size={18} />
                                        : item.idServiceType === 3 ? <Telephone color="#0099CC" size={18} />
                                            : <Phone color="#0099CC" size={18} />
                                    }
                                </Dropdown.Item>)
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
            <td>
                {!isDisabled &&
                    <input className="input-table" name="addressValue" value={address.addressValue} onChange={handleChangeValue} />
                }
            </td>
            <td>
                <Dropdown onSelect={eventKey => {
                    setToggleOptions(eventKey);
                }}>
                    <Dropdown.Toggle id="dropdown-custom-components" variant="light">
                        {!toggleOptions ? mailOptions[0] : toggleOptions}
                    </Dropdown.Toggle>

                    <Dropdown.Menu name="addressOption" value={address.idServiceType} >
                        {
                            mailOptions.map((item, index) => {
                                return (<Dropdown.Item value={item} key={index} eventKey={item} onSelect={handleChangeOption} disabled={isDisabledSelect}>
                                    {item}
                                </Dropdown.Item>)
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
            <td>
                <button type='button' className="btn btn_table btn-primary" style={breakpoint > width ? { backgroundColor: "red", marginBottom: "5px" } : { backgroundColor: "red", }} onClick={() => props.onRequestSaveAddress(address)} ><FaIcons.FaRegSave style={{ height: '20px' }} /></button> &nbsp;
                <button type='button' className="btn btn_table btn-primary" style={breakpoint > width ? { backgroundColor: "#0099CC", marginBottom: "5px" } : { backgroundColor: "#0099CC", }} onClick={() => props.onRequestCancelRow()}><FaIcons.FaArrowLeft style={{ height: '20px' }} /></button>
            </td>
        </tr>
    )
}

export { NewAddressRow };